module.exports = __webpack_public_path__ + "img/firm.128152a0.png";